import React from 'react'
import { TablePagination as MuiTablePagination } from '@mui/material'
import { PaginationConfig } from '../types'

interface TablePaginationProps {
  pagination: PaginationConfig
}

export const TablePagination: React.FC<TablePaginationProps> = ({
  pagination
}) => {
  const handleChangePage = (
    _event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    pagination.onPageChange(newPage, pagination.pageSize)
  }

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const newPageSize = parseInt(event.target.value, 10)
    pagination.onPageChange(0, newPageSize) // Resetear a página 0 cuando cambia el tamaño
  }

  return (
    <MuiTablePagination
      component='div'
      count={pagination.total}
      page={pagination.page}
      rowsPerPage={pagination.pageSize}
      onPageChange={handleChangePage}
      onRowsPerPageChange={handleChangeRowsPerPage}
      rowsPerPageOptions={pagination.pageSizeOptions || [5, 10, 20, 50]}
      labelRowsPerPage='Filas por página:'
      labelDisplayedRows={({ from, to, count }) =>
        `${from}-${to} de ${count !== -1 ? count : `más de ${to}`}`
      }
      sx={{
        borderTop: (theme) => `1px solid ${theme.palette.divider}`,
        backgroundColor: (theme) => theme.palette.background.paper,
        marginBottom: 0,
        paddingBottom: '0px'
      }}
      SelectProps={{
        native: true
      }}
    />
  )
}
